import { Action } from '@reduxjs/toolkit';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

import { IdleTimerProviderMeldSkade } from '../components/idle-timer-provider/idle-timer-provider-meld-skade';
import { useBankregnr, useConfig } from '../config';
import { useKunde } from '../kundeinfo/kunde-context';
import { userHasFilledInInfo } from '../meldskade/reducer/skademelding-reducer';
import { AppState } from '../reducers';
import { useWindowScrollTop } from '../sporsmalsflyt/hooks';
import { previousStepAction } from '../sporsmalsflyt/reducer/sporsmalsflyt-actions';
import { isFirstSporsmal } from '../sporsmalsflyt/reducer/sporsmalsflyt-state';
import { Sporsmalsflyt } from '../sporsmalsflyt/sporsmalsflyt';
import { SporsmalsflytResultDTO } from '../types/generated-types';
import { navigateToSitecorePage } from '../urler';
import { SideType } from '../utils/piwik-utils';
import { KlageOppsummering } from './klage-oppsummering';
import {
    fetchedKlageSporsmalsflyt,
    fetchingKlageSporsmalsflyt,
    fetchKlageSporsmalsflytFailed,
    getKlageApi,
} from './reducer/klage-actions';

export const Klage = () => {
    const { url } = useConfig().links.meldskadelandingsside;
    const klageState = useSelector((state: AppState) => state.klage);
    const windowScrollTop = useWindowScrollTop();
    const dispatch: Dispatch<Action> = useDispatch();
    const bankregnr = useBankregnr();
    const { getKundeinfo } = useKunde();

    const getKlageSporsmalsflyt = useCallback(() => {
        dispatch(fetchingKlageSporsmalsflyt());
        getKlageApi(bankregnr)
            .then((result: SporsmalsflytResultDTO) => dispatch(fetchedKlageSporsmalsflyt(result.sporsmalsflyt)))
            .catch(() => dispatch(fetchKlageSporsmalsflytFailed()));
    }, [bankregnr, dispatch]);

    useEffect(() => {
        getKundeinfo().finally(() => {
            getKlageSporsmalsflyt();
        });
    }, [getKlageSporsmalsflyt, dispatch, getKundeinfo]);

    const onPrev = () => {
        if (isFirstSporsmal(klageState.sporsmalsflytState.besvarteSporsmal)) {
            navigateToSitecorePage(url);
        }
        windowScrollTop();
        dispatch(previousStepAction());
    };

    const header = {
        title: 'Klage',
        subtitle: '',
    };

    return (
        <IdleTimerProviderMeldSkade skademeldingstype="klage">
            <Sporsmalsflyt
                header={header}
                currentSteg={klageState.sporsmalsflytState.currentSteg}
                userHasFilledInInfo={userHasFilledInInfo(klageState)}
                Oppsummering={KlageOppsummering}
                onPrev={onPrev}
                retryFetchingData={() => {
                    getKundeinfo().finally(() => {
                        getKlageSporsmalsflyt();
                    });
                }}
                skjemaside={{ type: SideType.Skjemaside, skademeldingstype: 'klage' }}
            />
        </IdleTimerProviderMeldSkade>
    );
};
